export interface IArchivo {
  idArchivo: string;
  url: string;
  ruta: string;
  proveedor: string;
  tipoArchivo: string;
  fechaCreacion: string;
  usuarioCreacion: string;
  fechaActualizacion: string;
  usuarioActualizacion: string;
}

export class Archivo {
  idArchivo: string;
  url: string;
  ruta: string;
  proveedor: string;
  tipoArchivo: string;
  fechaCreacion: Date;
  usuarioCreacion: string;
  fechaActualizacion: Date;
  usuarioActualizacion: string;

  constructor(data: IArchivo) {
    this.idArchivo = data.idArchivo;
    this.url = data.url;
    this.ruta = data.ruta;
    this.proveedor = data.proveedor;
    this.tipoArchivo = data.tipoArchivo;
    this.fechaCreacion = new Date(data.fechaCreacion);
    this.usuarioCreacion = data.usuarioCreacion;
    this.fechaActualizacion = new Date(data.fechaActualizacion);
    this.usuarioActualizacion = data.usuarioActualizacion;
  }

}
